import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { saveAs } from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from 'src/app/core/services/data.service';
import { Router } from '@angular/router';
import { SsoService } from '@devinforius/i-sso';

@Component({
  selector: 'app-dialog-releases-notes',
  templateUrl: './dialog-releases-notes.component.html',
  styleUrls: ['./dialog-releases-notes.component.scss'],
})
export class DialogReleasesNotesComponent implements OnInit {
  public isversionNotUpdated = false;
  public actualVersion: string = '';
  public releaseNotes = [];
  public urlDoc: string = '';
  public data: unknown = [
    {
      version: '3.1.4',
      text: [
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Tableau des points : Correction du changement de page, du nombre d’éléments par page`,
            `Tableau des points : Correction dans l’export des points lus et non lus`,
            `Tableau des points : Filtre sur plusieurs services`,
            `Modification du point : Affichage de l'échevinat`,
            `Type de séance : correction suite à la perte du paramétrage du nom de la séance lors de mise à jour de celui-ci`,
          ],
        },
      ],
    },
    {
      version: '3.1.3',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            `Affichage du nombre de fichier dans un point et une séance`,
            `Ajout d’un évènement présélectionne le point qui a été selectionné`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Editeur de texte: Copié/Coller lorsqu’un texte est sélectionné`,
            `Recherche sur un point via son Id`,
            `Affichage des modèles de point`,
            `Bouton pour changer le mode d'affichage de la séance`,
            `Affichage du scroll dans le formulaire d'un point`,
          ],
        },
      ],
    },
    {
      version: '3.1.2',
      text: [
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [`Contenu des fichiers du point sont bien visible à l'ouverture dès la première tentative"`],
        },
      ],
    },
    {
      version: '3.1.1',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: ['Pour information : Ajout du message', `Ajout du type dans les liens`],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Listing des points en "Pour Action"`,
            `Pour information : affichage du demandeur`,
            `Rechargement des documents lors du changement de point`,
            `Recherche avancée : filtre sur les utilisateurs et contacts`,
            `Création/Duplication d'un point empêcher les cliques multiples`,
            `Modification d'un point : doublon de la séance`,
            `Confirmation multiple lorsque l'on quitte un point`,
            `Génération des documents par les agents`,
            `Confirmation multiple lorsque l'on quitte un point`,
          ],
        },
      ],
    },
    {
      version: '3.1.0',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            'Gestion des liens : Ajouter des liens entre des points et/ou entre un point et une fiche courrier, les liens sont cliquables',
            `Affichage des documents et fichiers d'une séance et d’un point`,
            `Affichage actions envoyées au services, groupes et/ou utilisateurs`,
            `Affichage recherche avancée`,
            `Envoyer pour information un point à un service`,
            `Correcteur orthographique mis à jour`,
            `Copier/coller à la création ou modification d’un point formate la police et la taille du texte en fonction du paramétrage mis en place par défaut`,
            `La taille des images sera automatique réduite si celle-ci dépasse la limite fixée dans l’application afin d’éviter de bloquer un point`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Génération d’extrait par un agent bloqué si le point n’est pas clôturé`,
            `Ordre chronologique des séances dans les registres`,
            `Affichage participants absents de la séance`,
            `Formulaire des extrait conforme qui était grisé`,
          ],
        },
      ],
    },
    {
      version: '3.0.0',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            'Registre des pv + jeton de présence ',
            'Glisser/déposer des points afin de renuméroter la liste des points',
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            'Compteur des points qui affichait 0 (en rédaction, à corriger,…)',
            'Bouton verrouillé via action dans le point',
            'Ajouter en fichier via le glisser déposer',
            'Service s’affichait empty à la création/modification d’un point',
            'Affichage liste des points dans le désordre suite à l’ordre de passage',
            'Destinataires d’un point pour info ne s’affichaient plus',
            'Vue liste des points, affichage des destinataires ne s’actualisait pas en passant d’un point à l’autre',
            'Date de la séance vide à la modification d’un point envoyé en correction',
          ],
        },
      ],
    },
    {
      version: '2.4.1',
      text: [
        {
          title: 'CORRECTIONS ',
          content: [],
          list: ['Corrections de bugs.'],
        },
      ],
    },
    {
      version: '2.4.0',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            `Ajout de l'information des points lu et non lu`,
            `Génération de fichiers - Points non inclus dans une séance`,
            `Point - Amélioration de l'historique`,
            `Recherche avancée de points - Ajout des utilisateurs inactifs`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Duplication d'un point - Suppression des étapes`,
            `Duplication d'un point - Problème lors d'une deuxième duplication`,
            `Duplication d'un point - Reprise des fichiers`,
            `Recherche avancée de points - Agent traitant`,
            `Point - Sélection du destinataire principal `,
            `Point - Date d'échéance des actions`,
            `Point - Sélection du type de point en fonction du type parametré dans la séance`,
          ],
        },
      ],
    },
    {
      version: '2.3.0',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            `Réorganisation des points dans la séance"`,
            `Création d'un point`,
            `Modification dans l'import des fichiers iCourrier`,
            `Modification dans le changement de statut en masse pour les séances et pour les points`,
            `Recherche avancée de points - Ajout du classement`,
            `Fusion des documents - ajout de la fusion des extraits conformes`,
            `Extrait conforme - Ajout de la recherche des signataires`,
            `Extrait conforme - Ajout des annexes en fonction du paramétrage`,
            `iScan - automatisation de l'encodage pour Mandataire et Citoyen`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Recherche avancée dans les séances sur les statuts`,
            `Affichage de la date dans l'historique`,
            `Problème dans le nombre de votants lorsqu'une personne est encodée absente`,
            `Perte des accès iDélibé Mandataire à la modification d'une fiche contact`,
            `Compteur des points`,
            `Affichage des évènements dans la séance`,
          ],
        },
      ],
    },
    {
      version: '2.2.0',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            `Ajout d'un sous-menu dans les "Pour la sélection"`,
            `Recherche avancée des points: Refonte visuelle`,
            `Recherche avancée des points: Ajout du créateur`,
            `Point: Agent traitant ne peut être qu'un utilisateur`,
            `Point: Création du classement directement depuis iDelibé`,
            `Point: Ajout de la recherche dans le classement`,
            `Point: Ajout du "passage service" dans la création et la mise à jour du point`,
            `Documents: Ne plus rendre exportable l'ancienne version du document lors de la génération d'un nouveau.`,
            `Services: Ajout de la recherche dans les listings de sélection`,
            `IScan: Optimisation de la création des documents`,
            `Actions: Optimisations de la page de listing des actions`,
            `Actions: Ajout du statut dans le traitement de l'action`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Suppression d'un évènement`,
            `Point reporté: Garder le rédacteur initial du point`,
            `Point reporté: Historique`,
            `Génération de documents: des puces changent de format à la génération`,
            `Traitement d'une action`,
            `Sélection du service via iCourrier`,
          ],
        },
      ],
    },
    {
      version: '1.9.0',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [],
          list: [
            `Signature électronique des documents`,
            `iScan : Refonte`,
            `Documents : Ajout des versions`,
            `Documents : Fusions`,
          ],
        },
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            `Export mandataire : Ordre des fichiers`,
            `Bandeau d'avertissement concernant l'ordre réel`,
            `Éditeur de texte: Correcteur orthographique (Français, Anglais, Néerlandais, Allemand)`,
            `Éditeur de texte: Ajout de la police "Open Sans"`,
            `Report d'un point`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Suppression du lien entre une séance et un lieu inconnu`,
            `Message d'erreur lors de la suppression de participant`,
            `Génération d'extrait conforme`,
            `Duplication d'un point depuis la séance`,
            `Pop-up lors de "pas de vote"`,
            `Fichier importé d'un courrier ne se coche pas "visible mandataire" ou "visible citoyen" automatiquement`,
          ],
        },
      ],
    },
    {
      version: '1.7.4',
      text: [
        {
          title: 'AMÉLIORATIONS',
          content: [],
          list: [`Changement d'emplacement du statut de la séance`, `Refonte du menu action en haut à droite`],
        },
        {
          title: 'CORRECTIONS',
          content: [],
          list: [
            `Adaptation de la vue des différentes données d'un point`,
            `Correction de la remontée de la donnée « titre du point » et augmentation de
              la limite de caractères, « type de décision qui par défaut sera décide», provenant de 3P`,
            `Si un point 3P a été archivé dans idélibé, vous pourrez le mettre à jour en le
              réimportant de 3P pour ensuite, le traiter et l'importer dans votre séance.`,
            `Reporter un point via le menu séance `,
          ],
        },
      ],
    },
    {
      version: '1.7.3',
      text: [
        {
          title: 'AMÉLIORATIONS',
          content: [],
          list: [
            `La mise à jour du titre du point lorsque celui-ci est modifié.`,
            `Problème de multiplication d’un point dans une séance qui entraine une mauvaise numérotation`,
          ],
        },
        {
          title: 'CORRECTIONS',
          content: [],
          list: [
            `iScan: possibilité de supprimer une page et de pouvoir identifier manuellement le fichier grâce à l’ID du point ou de la séance, s’il y a un problème de lecture de QR Code`,
            `Possibilité d’ajouter plusieurs documents en une fois dans un point`,
            `Suppression d’une séance par le gestionnaire si le droit lui est octroyé`,
            `Ajout d’un focus dans le menu point, qui met le curseur directement dans la zone de recherche.`,
            `Onglet du navigateur contient plus de détails pour identifier le point ou la séance `,
          ],
        },
      ],
    },
    {
      version: '1.7.2',
      text: [
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Créer un point via 3P`,
            `Affichage des liens`,
            `Affichage liste séance`,
            `Création d’un courrier sortant`,
            `Recherche avancée dans le menu séance`,
            `Tri colonne qui ne restait pas en mémoire dans le menu séance`,
            `Filtre dans le menu point`,
          ],
        },
      ],
    },
    {
      version: '1.7.1',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [],
          list: [
            `Extrait conforme avec un droit qui permet de modifier les signatures et de les générer en lot et/ou individuellement par utilisateur (droit à activer)`,
          ],
        },
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            `Une icone a été ajoutée dans la vue séance qui permet de visualiser directement si un point est en cours de modification par un utilisateur`,
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            `Modification multiple des statuts d'un point`,
            `Envoi multiple de point en correction`,
            `Ajouter des fichiers dans une séance`,
            `Action visible dans l'onglet destinataire des points non valide pour séance`,
            `Permettre de descendre plus bas sur l'écran d'un point pour les petits écran`,
          ],
        },
      ],
    },
    {
      version: '1.7.0',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [],
          list: [
            "Mise en forme des ruptures dans l'OJ et le PV",
            'Champ de fusion id du point',
            'Lien icourrier-idélibé',
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            'Recherche avancée',
            'Chargement historique',
            'Affichage des séances après avoir fait un tri sur la date de séance',
          ],
        },
      ],
    },
    {
      version: '1.6.0',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [],
          list: ['Verrouillage de la séance entraine le verrouillage automatique des points.'],
        },
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            'Tableau menu point : affichage par défaut des colonnes, redimensionner colonnes.',
            'Duplication de point : vider le statut, le type de séance, la date de séance et le type de décision + le bouton dupliquer est disponible pour chaque point dans la vue tableau des points de la séance',
            "Gestionnaire : bloquer l'ajout d'un point dans une séance clôturée",
            "Extrait de délibération : les agents ne peuvent générer d'aperçu des extraits. Ils peuvent y avoir accès dans l'onglet fichier du fichier dès que le gestionnaire l'aura générer.",
            "Création d'un point : la fenêtre du titre d'un point s'adapte à la longueur de l'objet du point.",
            'Recherche rapide dans le menu point : permet de rechercher sur des chiffres.',
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: ['Vote : ordre de préséance respecté.', 'Limiter les actions des agents dans un point.'],
        },
      ],
    },
    {
      version: '1.5.1',
      text: [
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            "Affichage du n° ID du point + recherche sur l'ID",
            'Verrouiller la séance, verrouille les points aussi',
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            "Bouton pour importer des fichiers d'une fiche courrier dans le point fonctionne sans devoir cliquer sur modifier",
            'Bouton 3P fonctionne correctement et affiche bien les points',
            "Recherche avancée - les agents ne voient dans la liste des services que les services dont ils sont membres (je vous rassure avant ils voyaient tous les services mais n'avaient de toute façon pas de résultat sauf si un paramètre particulier était activé)",
            "Catégorie de point affiche que les points dans la catégorie sélectionnée (sera effectif demain matin car on l'a oublié dans la version de cette fin de journée)",
            'iScan - les fichiers ajoutés sont considérés comme des fichiers associés et plus des annexes',
            "iScan - les fichiers ajoutés dans le point sont bien complet au téléchargement et à l'aperçu",
            'Bouton supprimer des fichier est revenu',
            'Recherche avancée - tous les critères sont bien pris en compte',
            "Modification d'un point - toutes les données peuvent être modifiés'",
          ],
        },
      ],
    },
    {
      version: '1.5.0',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [],
          list: [
            'Ajout de la recherche dans le contenu du point',
            "Possibilité d'ajouter des ET et des OU dans la recherche du point",
          ],
        },
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            "Affichage des Agents traitant par ordre alphabétique dans la création d'un point",
            'Empêcher la modification du statut du point lorsque le point est verrouillé en écriture',
            "Suppression de la pagination du listing des points d'une séance",
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            'iScan, mauvais liens entre le fichier et le point ou la séance',
            'Redirection et tris dans le listing des séances',
            'Affichage de mauvais fichiers dans les points sans fichier',
          ],
        },
      ],
    },
    {
      version: '1.3.0 - 1.4.0',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [],
          list: ['Lecteur de code QR', 'Lien avec 3P'],
        },
        {
          title: 'AMÉLIORATIONS ',
          content: [],
          list: [
            "Génération par lot : il est possible d'écraser des documents déjà générés",
            'Éditeur : couleur noir par défaut + afficher les espaces par défaut',
            "Affichage tableau séance : garde en mémoire l'ordre et l'affichage des colonnes dans l'onglet des points dans la séance et des points prévus à la séance.",
            'Gestion de service : pouvoir ajouter un/plusieurs utilisateurs dans un/plusieurs services',
            'Changement du visuel pour le choix des votes',
          ],
        },
        {
          title: 'CORRECTIONS ',
          content: [],
          list: [
            "Afficher le nom de l'utilisateur qui a verrouillé le point en écriture",
            'Enlever le bandeau de verrouillage dès que le point est déverrouillé',
            "Caractères spéciaux ne poseront plus problème pour l'export vers mandataire",
            'Ajouter un point dans la bibliothèque via le bouton action dans le point',
            "Le texte ne s'affichait plus dans la motivation… via la modification du point",
            'Empêcher de créer plusieurs fois les mêmes séances',
            "Traiter l'action dans le menu action",
            'Filtre dans les tableaux',
          ],
        },
      ],
    },
    {
      version: '1.2.0',
      text: [
        {
          title: 'NOUVELLES FONCTIONNALITÉS',
          content: [
            "Accès concurrent : lorsqu'une personne modifie un point, celui-ci est bloqué en édition pour les autres utilisateurs.",
          ],
          list: [],
        },
        {
          title: 'AMÉLIORATIONS',
          content: [
            'Amélioration visuelle de la vue du menu séance, de la vue tableau et de la vue liste dans la séance.',
          ],
          list: [],
        },
        {
          title: 'CORRECTIONS',
          content: [],
          list: [
            "Blocage à l'enregistrement d'une modification d'un modèle de point",
            "Blocage à l'enregistrement d'une modification d'un point",
            "Duplication du contenu d'un point",
          ],
        },
      ],
    },
  ];
  public currentVersion: string;

  constructor(
    private ssoService: SsoService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public http: HttpClient,
    public dataService: DataService,
    public sanitizer: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.config.header = 'Notes de mise à jour';
    this.urlDoc = this.config.data.url;
    const globalConfig = JSON.parse(sessionStorage.getItem('globalConfig'));
    if (globalConfig) {
      this.currentVersion = globalConfig.currentVersion;
    }
  }

  download(file: File): void {
    const downloadURL = URL.createObjectURL(file);
    saveAs(downloadURL, file);
  }

  //! à supprimer quand la version 1.9.0 et 2.1.0 seront dépassée
  logout(): void {
    localStorage.removeItem('boxes');
    sessionStorage.clear();

    this.ssoService.logOut();
  }
}
